import { User } from "../types/user";

export const mockUsers: User[] = [
  {
    id: "user-001",
    firstName: "Jane",
    lastName: "Doe",
    email: "jane.doe@example.com",
    emailVerified: true,
    emailUpdatedAt: "2025-05-20T10:00:00Z",
    phoneNumber: "+12345678901",
    phoneNumberVerified: true,
    phoneNumberUpdatedAt: "2025-05-20T10:00:00Z",
    username: "janedoe",
    cognitoId: "cognito-001",
    registrationConfirmed: true,
    requiresPasswordReset: false,
    avatar: "https://i.pravatar.cc/150?u=jane",
    role: "DRIVER",
    createdAt: "2024-01-01T12:00:00Z",
    registrationCompleted: true,
    pushToken: "push-token-001",
    deleted: false,
    isOnline: true,
    lastOnlineAt: "2025-05-22T12:00:00Z",
    updatedAt: "2025-05-22T12:00:00Z",
    lastKnownDeviceId: "device-001",
    organizationId: "org-001",
    isGuestUser: false
  },
  {
    id: "user-002",
    firstName: "John",
    lastName: "Smith",
    email: "john.smith@example.com",
    emailVerified: true,
    emailUpdatedAt: "2025-05-20T10:00:00Z",
    phoneNumber: "+19876543210",
    phoneNumberVerified: true,
    phoneNumberUpdatedAt: "2025-05-20T10:00:00Z",
    username: "johnsmith",
    cognitoId: "cognito-002",
    registrationConfirmed: true,
    requiresPasswordReset: false,
    avatar: "https://i.pravatar.cc/150?u=john",
    role: "DRIVER",
    createdAt: "2024-02-01T12:00:00Z",
    registrationCompleted: true,
    pushToken: "push-token-002",
    deleted: false,
    isOnline: false,
    lastOnlineAt: "2025-05-21T08:00:00Z",
    updatedAt: "2025-05-21T08:00:00Z",
    lastKnownDeviceId: "device-002",
    organizationId: "org-001",
    isGuestUser: false
  },
  {
    id: "user-003",
    firstName: "Emily",
    lastName: "Nguyen",
    email: "emily.nguyen@example.com",
    emailVerified: true,
    emailUpdatedAt: "2025-05-20T10:00:00Z",
    phoneNumber: "+14151234567",
    phoneNumberVerified: true,
    phoneNumberUpdatedAt: "2025-05-20T10:00:00Z",
    username: "emilynguyen",
    cognitoId: "cognito-003",
    registrationConfirmed: true,
    requiresPasswordReset: false,
    avatar: "https://i.pravatar.cc/150?u=emily",
    role: "DRIVER",
    createdAt: "2024-03-15T12:00:00Z",
    registrationCompleted: true,
    pushToken: "push-token-003",
    deleted: false,
    isOnline: true,
    lastOnlineAt: "2025-05-23T09:30:00Z",
    updatedAt: "2025-05-23T09:30:00Z",
    lastKnownDeviceId: "device-003",
    organizationId: "org-002",
    isGuestUser: false
  },
  {
    id: "user-004",
    firstName: "Carlos",
    lastName: "Lopez",
    email: "carlos.lopez@example.com",
    emailVerified: true,
    emailUpdatedAt: "2025-05-20T10:00:00Z",
    phoneNumber: "+15145554444",
    phoneNumberVerified: true,
    phoneNumberUpdatedAt: "2025-05-20T10:00:00Z",
    username: "carloslopez",
    cognitoId: "cognito-004",
    registrationConfirmed: true,
    requiresPasswordReset: false,
    avatar: "https://i.pravatar.cc/150?u=carlos",
    role: "DRIVER",
    createdAt: "2024-04-01T12:00:00Z",
    registrationCompleted: true,
    pushToken: "push-token-004",
    deleted: false,
    isOnline: false,
    lastOnlineAt: "2025-05-22T13:15:00Z",
    updatedAt: "2025-05-22T13:15:00Z",
    lastKnownDeviceId: "device-004",
    organizationId: "org-001",
    isGuestUser: false
  },
  {
    id: "user-005",
    firstName: "Aisha",
    lastName: "Khan",
    email: "aisha.khan@example.com",
    emailVerified: true,
    emailUpdatedAt: "2025-05-20T10:00:00Z",
    phoneNumber: "+16135553333",
    phoneNumberVerified: true,
    phoneNumberUpdatedAt: "2025-05-20T10:00:00Z",
    username: "aishakhan",
    cognitoId: "cognito-005",
    registrationConfirmed: true,
    requiresPasswordReset: false,
    avatar: "https://i.pravatar.cc/150?u=aisha",
    role: "DRIVER",
    createdAt: "2024-05-01T12:00:00Z",
    registrationCompleted: true,
    pushToken: "push-token-005",
    deleted: false,
    isOnline: true,
    lastOnlineAt: "2025-05-23T11:00:00Z",
    updatedAt: "2025-05-23T11:00:00Z",
    lastKnownDeviceId: "device-005",
    organizationId: "org-002",
    isGuestUser: false
  },
  {
    id: "user-006",
    firstName: "Liam",
    lastName: "Chen",
    email: "liam.chen@example.com",
    emailVerified: true,
    emailUpdatedAt: "2025-05-20T10:00:00Z",
    phoneNumber: "+14165556666",
    phoneNumberVerified: true,
    phoneNumberUpdatedAt: "2025-05-20T10:00:00Z",
    username: "liamchen",
    cognitoId: "cognito-006",
    registrationConfirmed: true,
    requiresPasswordReset: false,
    avatar: "https://i.pravatar.cc/150?u=liam",
    role: "DRIVER",
    createdAt: "2024-06-01T12:00:00Z",
    registrationCompleted: true,
    pushToken: "push-token-006",
    deleted: false,
    isOnline: false,
    lastOnlineAt: "2025-05-23T07:45:00Z",
    updatedAt: "2025-05-23T07:45:00Z",
    lastKnownDeviceId: "device-006",
    organizationId: "org-003",
    isGuestUser: false
  },
  {
    id: "user-007",
    firstName: "Olivia",
    lastName: "Martinez",
    email: "olivia.martinez@example.com",
    emailVerified: true,
    emailUpdatedAt: "2025-05-20T10:00:00Z",
    phoneNumber: "+14167778888",
    phoneNumberVerified: true,
    phoneNumberUpdatedAt: "2025-05-20T10:00:00Z",
    username: "oliviamartinez",
    cognitoId: "cognito-007",
    registrationConfirmed: true,
    requiresPasswordReset: false,
    avatar: "https://i.pravatar.cc/150?u=olivia",
    role: "DRIVER",
    createdAt: "2024-07-01T12:00:00Z",
    registrationCompleted: true,
    pushToken: "push-token-007",
    deleted: false,
    isOnline: true,
    lastOnlineAt: "2025-05-23T14:00:00Z",
    updatedAt: "2025-05-23T14:00:00Z",
    lastKnownDeviceId: "device-007",
    organizationId: "org-003",
    isGuestUser: false
  }
];
